module.exports = __webpack_public_path__ + "static/img/start.73d6368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/RoundMove/start.jpg
// module id = O/2X
// module chunks = 1